import { createContext, useContext, useMemo, useRef, useState } from "react";
import { useQuery, useMutation } from "@tanstack/react-query";
import useToaster from "../../components/alert";
import Const from "../../utils/constant";
import { getHome, updateHome } from "../../api/home";

import { getIntialValues, generatePayload } from "./helper";
const PageContext = createContext();

export const PageProvider = ({ children }) => {
  const userImagesArray = useRef();
  const scaleArrayRef = useRef();
  const trainersArrayRef = useRef();
  const toolsArrayRef = useRef();
  const levelUpsArrayRef = useRef();
  const stepsArrayRef = useRef();
  const multiTitleArrayRef = useRef();
  const toaster = useToaster();
  // The scale row waiting on "Are you sure?" (its index), or null when nothing is.
  const [scaleToDelete, setScaleToDelete] = useState(null);

  const getHomeQuery = useQuery({
    queryKey: ["home"],
    queryFn: getHome,
  });
  const updateHomeQuery = useMutation({ mutationFn: updateHome });

  const initialValues = useMemo(() => {
    const homeData = getHomeQuery?.data?.data?.data?.[0] || {};

    return getIntialValues(homeData.page_content);
  }, [getHomeQuery]);

  const handleSubmit = async (values) => {
    const payload = generatePayload(values);
    const homeData = getHomeQuery?.data?.data?.data?.[0] || {};

    updateHomeQuery.mutate(
      { page_content: payload, id: homeData.id },
      {
        onSuccess: () => {
          toaster.success(Const.MESSAGES.SUCCESS, Const.MESSAGES.DATA_IS_UPDATED_SUCCESSFULLY);
          getHomeQuery.refetch();
        },
      },
    );
  };

  const handleUserImagesAdd = () => {
    userImagesArray.current.push({ image_url: "" });
  };

  const handleUserImagesDelete = (index) => () => {
    userImagesArray.current.remove(index);
  };

  const handleScaleAdd = () => {
    scaleArrayRef.current?.push({
      title: "",
      description: "",
      image_url: {
        desktop: "",
        mobile: "",
      },
    });
  };

  // Ask first; the row is removed only once the admin confirms.
  const handleScaleDelete = (index) => () => {
    setScaleToDelete(index);
  };

  const handleConfirmScaleDelete = () => {
    if (scaleToDelete !== null) scaleArrayRef.current?.remove(scaleToDelete);
    setScaleToDelete(null);
  };

  const handleCancelScaleDelete = () => {
    setScaleToDelete(null);
  };

  const handleTrainerAdd = () => {
    trainersArrayRef.current?.push({
      count: "",
      title: "",
    });
  };
  const handleTrainerDelete = (index) => () => {
    trainersArrayRef.current?.remove(index);
  };


 const handleAddStep = () => {
    stepsArrayRef.current?.push({
      title: "",
      description: "",
      steps: "",
      image: "",
    });
  };

  const handleDeleteStep = (index) => () => {
    stepsArrayRef.current?.remove(index);
  };


  const handleToolAdd = () => {
    toolsArrayRef.current?.push({ image_url: "" });
  };

  const handleToolDelete = (index) => () => {
    toolsArrayRef.current?.remove(index);
  };

  const handleLevelUpAdd = () => {
    levelUpsArrayRef.current?.push({
      basis: "",
      before: "",
      after: "",
    });
  };

  const handleLevelUpDelete = (index) => () => {
    levelUpsArrayRef.current?.remove(index);
  };


  const handleMultiTitleAdd = () => {
  multiTitleArrayRef.current?.push({
    title: "",
  });
};

const handleMultiTitleDelete = (index) => () => {
  multiTitleArrayRef.current?.remove(index);
};




  return (
    <PageContext.Provider
      value={{
        initialValues,
        handleSubmit,
        getHomeQuery,
        handleUserImagesAdd,
        handleUserImagesDelete,
        userImagesArray,
        handleScaleAdd,
        handleScaleDelete,
        scaleToDelete,
        handleConfirmScaleDelete,
        handleCancelScaleDelete,
        scaleArrayRef,
        trainersArrayRef,
        handleTrainerAdd,
        handleTrainerDelete,
        toolsArrayRef,
        handleToolAdd,
        handleToolDelete,
        levelUpsArrayRef,
        handleLevelUpAdd,
        handleLevelUpDelete,
        updateHomeQuery,
        handleAddStep,
        handleDeleteStep,
        stepsArrayRef,
        multiTitleArrayRef,
        handleMultiTitleAdd,
        handleMultiTitleDelete,
      }}
    >
      {children}
    </PageContext.Provider>
  );
};
export const usePageProvider = () => {
  return useContext(PageContext);
};
